import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { getCategoryConfig } from "../../../utils/bulkOperationsConfig";
import { findReport } from "./reportRegistry";

/**
 * Resolves /bulk-order-operations/client-reports/:report to its screen.
 *
 * Mirrors CategoryRouter one level down: an unknown report, or a country that has not enabled the
 * category, falls back rather than rendering an empty page. The route guard has already
 * established the user may be here.
 */
const ReportRouter = () => {
	const { report: reportKey } = useParams<{ report: string }>();
	const report = findReport(reportKey);

	if (!getCategoryConfig("client-reports")?.enabled) {
		return <Navigate to={"/bulk-order-operations"} replace />;
	}

	if (!report) {
		return (
			<Navigate to={"/bulk-order-operations/client-reports"} replace />
		);
	}

	return <>{report.component}</>;
};

export default ReportRouter;
